import ApiError500Handler from './ApiError500Handler'

const STATUS_CODE = 403

class ApiError403Handler {
  handleError (error) {
    if (error.response.status === STATUS_CODE) {
      return error.response.statusText
    }

    ApiError500Handler.handleError(error)
  }
}

export default new ApiError403Handler()
